export default __webpack_public_path__ + "static/media/keyboardTab.8ed07a39.svg";